//# sourceMappingURL=llm_capacity.mjs.map
/// <reference types="./llm_capacity.d.mts" />
import * as $tab_bar from "../../../altar/altar/tab_bar.mjs";
import * as $organization from "../../../data_types/data/auth/organization.mjs";
import * as $llm_capacity from "../../../data_types/data/llm_capacity.mjs";
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../ds/ds/components/modal.mjs";
import * as $segmented_button from "../../../ds/ds/components/segmented_button.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $utils from "../../../ds/ds/utils.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $ai_config_effects from "../../admin/effects/ai_config.mjs";
import * as $llm_capacity_effects from "../../admin/effects/llm_capacity.mjs";
import * as $route from "../../data/route.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, Error, toList, Empty as $Empty } from "../../gleam.mjs";
import * as $capacity from "../../view/administration/llm_capacity/capacity.mjs";
import * as $customers from "../../view/administration/llm_capacity/customers.mjs";
import * as $rate_limits from "../../view/administration/llm_capacity/rate_limits.mjs";
import * as $common from "../../view/common.mjs";

const langfuse_environments = /* @__PURE__ */ toList(["prod", "staging", "dev"]);

function count(count) {
  return ("(" + $int.to_string(count)) + ")";
}

function tab_link(tab, title) {
  let _pipe = new $route.Administration(new $route.LlmCapacity(tab));
  let _pipe$1 = $route.to_uri(_pipe);
  return $tab_bar.tab(_pipe$1, toList([$h.text(title)]));
}

function last_refreshed(rate_limits) {
  let _pipe = rate_limits;
  let _pipe$1 = $list.map(_pipe, (r) => { return r.refreshed_at; });
  let _pipe$2 = $list.max(_pipe$1, $timestamp.compare);
  let _pipe$3 = $option.from_result(_pipe$2);
  return $option.map(_pipe$3, $rate_limits.local_time_text);
}

function use_fetch_usage_by_org(store, environment, dispatch) {
  return ((_capture) => { return $redraw.use_effect(_capture, [environment]); })(
    () => {
      let _pipe = $dict.get(
        store.llm_usage_by_org,
        [environment, $customers.langfuse_days],
      );
      let _pipe$1 = $result.unwrap(_pipe, new $remote.NotLoaded());
      return $remote.load(
        _pipe$1,
        () => {
          dispatch(
            $llm_capacity_effects.fetch_llm_usage_by_org(
              environment,
              $customers.langfuse_days,
            ),
          );
          return undefined;
        },
      );
    },
  );
}

function use_fetch_customers(organizations, dispatch) {
  return ((_capture) => {
    return $redraw.use_effect(_capture, [$list.length(organizations)]);
  })(
    () => {
      if (organizations instanceof $Empty) {
        return undefined;
      } else {
        dispatch($ai_config_effects.fetch_ai_configs());
        return $list.each(
          toList([$customers.short_window_months, $customers.long_window_months]),
          (months) => {
            dispatch($llm_capacity_effects.fetch_organizations_activity(months));
            return undefined;
          },
        );
      }
    },
  );
}

function use_fetch_rate_limits(store, dispatch) {
  return ((_capture) => { return $redraw.use_effect(_capture, []); })(
    () => {
      return $remote.load(
        store.llm_rate_limits,
        () => {
          dispatch($llm_capacity_effects.fetch_rate_limits());
          return undefined;
        },
      );
    },
  );
}

function confirm_refresh() {
  return $redraw.component_(
    "ConfirmLlmRateLimitsRefresh",
    (_use0) => {
      let deployments = _use0[0];
      let props = _use0[1];
      let on_cancel = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_confirm = $e.on_click(
        (_) => { return props.on_end(new Ok(undefined)); },
      );
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([$utils.stop_propagation()]),
            toList([
              $modal.title(toList([]), toList([$h.text("Refresh limits?")])),
              $modal.explanations(
                toList([]),
                toList([
                  $h.text(
                    ("This sends one short request to every LLM deployment (" + $int.to_string(
                      deployments,
                    )) + ") to read their limits. It takes about a minute or two.",
                  ),
                ]),
              ),
              $modal.actions(
                toList([]),
                toList([
                  $button.secondary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.primary(
                    toList([on_confirm]),
                    toList([$h.text("Refresh")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    confirm_refresh(),
    (confirm_refresh) => {
      return $redraw.compose(
        $capacity.view(),
        (capacity_tab) => {
          return $redraw.component_(
            "LlmCapacity",
            (_use0) => {
              let tab = _use0[0];
              let store = $store.use_state();
              let dispatch = $store.use_effect_dispatch();
              let modal = $modal.use_modal();
              let $ = $redraw.use_state("prod");
              let environment = $[0];
              let set_environment = $[1];
              let environment_picker = $segmented_button.segmented_button(
                (() => {
                  let _pipe = $segmented_button.on_selected(set_environment);
                  return $segmented_button.selected(
                    _pipe,
                    new Some(environment),
                  );
                })(),
                $list.map(
                  langfuse_environments,
                  (environment) => {
                    return $segmented_button.choice(
                      "Langfuse " + environment,
                      environment,
                    );
                  },
                ),
              );
              let _block;
              let $1 = store.organizations;
              if ($1 instanceof $remote.Loaded) {
                let organizations = $1[0][1];
                _block = organizations;
              } else {
                _block = toList([]);
              }
              let organizations = _block;
              use_fetch_rate_limits(store, dispatch);
              use_fetch_customers(organizations, dispatch);
              use_fetch_usage_by_org(store, environment, dispatch);
              let _block$1;
              let $2 = store.llm_rate_limits;
              if ($2 instanceof $remote.Loaded) {
                let rate_limits = $2[0];
                _block$1 = rate_limits;
              } else {
                _block$1 = toList([]);
              }
              let rate_limits = _block$1;
              let deployments = $list.length(rate_limits);
              let customer_count = $list.length(
                $customers.customers(
                  organizations,
                  store.organizations_ai_config,
                ),
              );
              let on_refresh = (_) => {
                $promise.map(
                  modal.open(
                    (props) => { return confirm_refresh([deployments, props]); },
                  ),
                  (confirmed) => {
                    if (confirmed instanceof Ok) {
                      dispatch($llm_capacity_effects.refresh_rate_limits());
                      return undefined;
                    } else {
                      return undefined;
                    }
                  },
                );
                return undefined;
              };
              return $l.column(
                toList([$l.gap(16)]),
                toList([]),
                toList([
                  $l.row(
                    toList([
                      $l.gap(16),
                      $l.align("center"),
                      $l.justify("space-between"),
                    ]),
                    toList([]),
                    toList([
                      $l.column(
                        toList([$l.gap(4)]),
                        toList([]),
                        toList([
                          $common.page_title("LLM capacity"),
                          $typography.text(
                            $typography.sm,
                            $typography.regular,
                            (() => {
                              if (tab instanceof $route.Capacity) {
                                return "Peak load per model at full capacity, from the LLM calls in " + "Langfuse, against the limits of each deployment.";
                              } else if (tab instanceof $route.RateLimits) {
                                return "Limits of each deployment, read from the headers of one short " + "request per deployment.";
                              } else {
                                return "Which models each customer uses, from their AI config, and how " + "much they ran recently.";
                              }
                            })(),
                          ),
                        ]),
                      ),
                      $l.row(
                        toList([$l.gap(12), $l.align("center")]),
                        toList([]),
                        toList([
                          (() => {
                            let $3 = last_refreshed(rate_limits);
                            if ($3 instanceof Some) {
                              let refreshed = $3[0];
                              return $typography.text(
                                $typography.sm,
                                $typography.regular,
                                "Limits refreshed " + refreshed,
                              );
                            } else {
                              return $h.none();
                            }
                          })(),
                          $button.primary(
                            toList([
                              $a.disabled(
                                store.llm_rate_limits instanceof $remote.Loading,
                              ),
                              $e.on_click(on_refresh),
                            ]),
                            toList([$h.text("Refresh limits")]),
                          ),
                        ]),
                      ),
                    ]),
                  ),
                  $tab_bar.tab_bar(
                    toList([
                      tab_link(new $route.Capacity(), "Capacity"),
                      tab_link(
                        new $route.RateLimits(),
                        "Rate limits " + count(deployments),
                      ),
                      tab_link(
                        new $route.Customers(),
                        "Customers " + count(customer_count),
                      ),
                    ]),
                  ),
                  (() => {
                    if (tab instanceof $route.Capacity) {
                      return capacity_tab([environment, environment_picker]);
                    } else if (tab instanceof $route.RateLimits) {
                      return $rate_limits.view(store.llm_rate_limits);
                    } else {
                      return $l.column(
                        toList([$l.gap(24)]),
                        toList([]),
                        toList([
                          $l.row(
                            toList([$l.justify("flex-end")]),
                            toList([]),
                            toList([environment_picker]),
                          ),
                          $customers.view(
                            organizations,
                            store.organizations_ai_config,
                            store.organizations_activity,
                            (() => {
                              let _pipe = $dict.get(
                                store.llm_usage_by_org,
                                [environment, $customers.langfuse_days],
                              );
                              return $result.unwrap(
                                _pipe,
                                new $remote.NotLoaded(),
                              );
                            })(),
                          ),
                        ]),
                      );
                    }
                  })(),
                ]),
              );
            },
          );
        },
      );
    },
  );
}
